import { PrimaryButton, PrimaryButtonProps } from '@components/Buttons/primary';
import { call } from '@packages/functions';
import { createMemo } from '@packages/react';
import { useTabs } from '@packages/tabs/lib/useTabs';
import React, { ReactElement, useCallback } from 'react';

/**
 * Go to next tab
 * @param props
 * @returns {*}
 * @constructor
 */
export const NextTab = createMemo<PrimaryButtonProps>(
    ({ component, onClick, ...props }): ReactElement => {
        props.children = props.children ?? 'Next';

        const { nextTab } = useTabs();
        const Component = component ?? PrimaryButton;

        const handleClick = useCallback(
            async (e) => {
                await call(onClick, e);
                await nextTab();
            },
            [nextTab, onClick],
        );

        return <Component onClick={handleClick} {...props} />;
    },
    {
        displayName: 'NextTab',
    },
);
